<template>
    <section>
        <div class="container">

        <div class="conteudo-privacidade">
            <h2 style="margin-bottom:50px;">POLÍTICA DE PRIVACIDADE</h2>
            <p><strong>SE&Ccedil;&Atilde;O 1 - INFORMA&Ccedil;&Otilde;ES GERAIS</strong></p>

<p>&nbsp;</p>

<p>A presente Pol&iacute;tica de Privacidade cont&eacute;m informa&ccedil;&otilde;es sobre coleta, uso, armazenamento, tratamento e prote&ccedil;&atilde;o dos dados pessoais dos usu&aacute;rios e visitantes do site Fibrillare, com a finalidade de demonstrar absoluta transpar&ecirc;ncia quanto ao assunto e esclarecer a todos interessados sobre os tipos de dados que s&atilde;o coletados, os motivos da coleta e a forma como os usu&aacute;rios podem gerenciar ou excluir as suas informa&ccedil;&otilde;es pessoais.</p>

<p>O presente documento foi elaborado em conformidade com a Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (Lei 13.709/18), o Marco Civil da Internet (Lei 12.965/14) (e o Regulamento da UE n. 2016/6790). Ainda, o documento poder&aacute; ser atualizado em decorr&ecirc;ncia de eventual atualiza&ccedil;&atilde;o normativa, raz&atilde;o pela qual se convida o usu&aacute;rio a consultar periodicamente esta se&ccedil;&atilde;o.</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 2 - COMO RECOLHEMOS OS DADOS PESSOAIS DO USU&Aacute;RIO E DO VISITANTE?</strong></p>

<p>Os dados pessoais do usu&aacute;rio e visitante s&atilde;o recolhidos pela plataforma da seguinte forma:</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Quando o usu&aacute;rio cria uma conta/perfil na plataforma: esses dados s&atilde;o os dados de identifica&ccedil;&atilde;o b&aacute;sicos, como exemplo: e-mail, nome completo, cidade de resid&ecirc;ncia e profiss&atilde;o). A partir deles, podemos identificar o usu&aacute;rio e o visitante, al&eacute;m de garantir uma maior seguran&ccedil;a e bem-estar &agrave;s suas necessidade. Ficam cientes os usu&aacute;rios e visitantes de que seu perfil na plataforma estar&aacute; acess&iacute;vel a todos demais usu&aacute;rios e visitantes da plataforma.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Quando um usu&aacute;rio e visitante acessa OU p&aacute;ginas do site OU o aplicativo: as informa&ccedil;&otilde;es sobre intera&ccedil;&atilde;o e acesso s&atilde;o coletadas pela empresa para garantir uma melhor experi&ecirc;ncia ao usu&aacute;rio e visitante. Estes dados podem tratar sobre as palavras-chaves utilizadas em uma busca, o compartilhamento de um documento espec&iacute;fico, coment&aacute;rios, visualiza&ccedil;&otilde;es de p&aacute;ginas, perfis, a URL de onde o usu&aacute;rio e visitante prov&ecirc;m, o navegador que utilizam e seus IPs de acesso, dentre outras que poder&atilde;o ser armazenadas e retidas.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Por interm&eacute;dio de terceiro: a plataforma recebe dados de terceiros, como Facebook e Google, quando um usu&aacute;rio faz login com o seu perfil de um desses sites. A utiliza&ccedil;&atilde;o desses dados &eacute; autorizada previamente pelos usu&aacute;rios junto ao terceiro em quest&atilde;o.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; outras</p>

<p>&nbsp;</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 3 - QUAIS DADOS PESSOAIS RECOLHEMOS SOBRE O USU&Aacute;RIO E VISITANTE?</strong></p>

<p><strong>&nbsp;</strong></p>

<p>Os dados pessoais do usu&aacute;rio e visitante recolhidos s&atilde;o os seguintes:</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados para a cria&ccedil;&atilde;o da conta/perfil na plataforma: e-mail, nome completo, cidade de resid&ecirc;ncia e profiss&atilde;o).</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados para otimiza&ccedil;&atilde;o da navega&ccedil;&atilde;o: acesso a p&aacute;ginas, palavras-chave utilizadas na busca, recomenda&ccedil;&otilde;es, coment&aacute;rios, intera&ccedil;&atilde;o com outros perfis e usu&aacute;rios, perfis seguidos, endere&ccedil;o de IP.</p>

<p>&nbsp;</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados para concretizar transa&ccedil;&otilde;es: dados referentes ao pagamento e transa&ccedil;&otilde;es, tais como, n&uacute;mero do cart&atilde;o de cr&eacute;dito e outras informa&ccedil;&otilde;es sobre o cart&atilde;o, al&eacute;m dos pagamentos efetuados.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Newsletter: o e-mail cadastrado pelo visitante que optar por se inscrever na Newsletter ser&aacute; coletado e armazenado at&eacute; que o usu&aacute;rio solicite o descadastro.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados sens&iacute;veis: a plataforma poder&aacute; coletar os seguintes dados sens&iacute;veis do usu&aacute;rio exemplo: origem &eacute;tnica ou racial, opini&atilde;o pol&iacute;tica, convic&ccedil;&atilde;o religiosa, dados gen&eacute;ticos, dados relativos &agrave; sa&uacute;de, orienta&ccedil;&atilde;o sexual)</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados relacionados a contratos: diante da formaliza&ccedil;&atilde;o do contrato de compra e venda ou de presta&ccedil;&atilde;o de servi&ccedil;os entre a plataforma e o usu&aacute;rio e visitante poder&atilde;o ser coletados e armazenados dados relativos a execu&ccedil;&atilde;o contratual, inclusive as comunica&ccedil;&otilde;es realizada entre a empresa e o usu&aacute;rio.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; outras</p>

<p>&nbsp;</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 3 - PARA QUE FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USU&Aacute;RIO E VISITANTE?</strong></p>

<p>Os dados pessoais do usu&aacute;rio e do visitante coletados e armazenados pela plataforma tem por finalidade:</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Bem-estar do usu&aacute;rio e visitante: aprimorar o produto e/ou servi&ccedil;o oferecido, facilitar, agilizar e cumprir os compromissos estabelecidos entre o usu&aacute;rio e a empresa, melhorar a experi&ecirc;ncia dos usu&aacute;rios e fornecer funcionalidades espec&iacute;ficas a depender das caracter&iacute;sticas b&aacute;sicas do usu&aacute;rio.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Melhorias da plataforma: compreender como o usu&aacute;rio utiliza os servi&ccedil;os da plataforma, para ajudar no desenvolvimento de neg&oacute;cios e t&eacute;cnicas.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; An&uacute;ncios: apresentar an&uacute;ncios personalizados para o usu&aacute;rio com base nos dados fornecidos.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Comercial: os dados s&atilde;o usados para personalizar o conte&uacute;do oferecido e gerar subs&iacute;dio &agrave; plataforma para a melhora da qualidade no funcionamento dos servi&ccedil;os.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Previs&atilde;o do perfil do usu&aacute;rio: tratamento automatizados de dados pessoais para avaliar o uso na plataforma.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados de cadastro: para permitir o acesso do usu&aacute;rio a determinados conte&uacute;dos da plataforma, exclusivo para usu&aacute;rios cadastrados</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Dados de contrato: conferir &agrave;s partes seguran&ccedil;a jur&iacute;dica e facilitar a conclus&atilde;o do neg&oacute;cio.</p>

<p>&nbsp;</p>

<p>&middot; &nbsp; &nbsp; &nbsp; &nbsp; Outras</p>

<p>&nbsp;</p>

<p>O tratamento de dados pessoais para finalidades n&atilde;o previstas nesta Pol&iacute;tica de Privacidade somente ocorrer&aacute; mediante comunica&ccedil;&atilde;o pr&eacute;via ao usu&aacute;rio, de modo que os direitos e obriga&ccedil;&otilde;es aqui previstos permanecem aplic&aacute;veis.</p>

<p><strong>&nbsp;</strong></p>

<p><strong>SE&Ccedil;&Atilde;O 4 - POR QUANTO TEMPO OS DADOS PESSOAIS FICAM ARMAZENADOS?</strong></p>

<p>&nbsp;</p>

<p>Os dados pessoais do usu&aacute;rio e visitante s&atilde;o armazenados pela plataforma durante o per&iacute;odo necess&aacute;rio para a presta&ccedil;&atilde;o do servi&ccedil;o ou o cumprimento das finalidades previstas no presente documento, conforme o disposto no inciso I do artigo 15 da Lei 13.709/18.</p>

<p>Os dados podem ser removidos ou anonimizados a pedido do usu&aacute;rio, excetuando os casos em que a lei oferecer outro tratamento.</p>

<p>&nbsp;</p>

<p>Ainda, os dados pessoais dos usu&aacute;rios apenas podem ser conservados ap&oacute;s o t&eacute;rmino de seu tratamento nas seguintes hip&oacute;teses previstas no artigo 16 da referida lei:</p>

<p>&nbsp;</p>

<p>I - cumprimento de obriga&ccedil;&atilde;o legal ou regulat&oacute;ria pelo controlador;</p>

<p>II - estudo por &oacute;rg&atilde;o de pesquisa, garantida, sempre que poss&iacute;vel, a anonimiza&ccedil;&atilde;o dos dados pessoais;</p>

<p>III - transfer&ecirc;ncia a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei;</p>

<p>IV - uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados.</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 5 - SEGURAN&Ccedil;A DOS DADOS PESSOAIS ARMAZENADOS</strong></p>

<p>&nbsp;</p>

<p>A plataforma se compromete a aplicar as medidas t&eacute;cnicas e organizativas aptas a proteger os dados pessoais de acessos n&atilde;o autorizados e de situa&ccedil;&otilde;es de destrui&ccedil;&atilde;o, perda, altera&ccedil;&atilde;o, comunica&ccedil;&atilde;o ou difus&atilde;o de tais dados.</p>

<p>Os dados relativas a cart&otilde;es de cr&eacute;dito s&atilde;o criptografados usando a tecnologia &quot;secure socket layer&quot; (SSL) que garante a transmiss&atilde;o de dados de forma segura e confidencial, de modo que a transmiss&atilde;o dos dados entre o servidor e o usu&aacute;rio ocorre de maneira cifrada e encriptada.</p>

<p>A plataforma n&atilde;o se exime de responsabilidade por culpa exclusiva de terceiro, como em caso de ataque de hackers ou crackers, ou culpa exclusiva do usu&aacute;rio, como no caso em que ele mesmo transfere seus dados a terceiros. O site se compromete a comunicar o usu&aacute;rio em caso de alguma viola&ccedil;&atilde;o de seguran&ccedil;a dos seus dados pessoais.</p>

<p>Os dados pessoais armazenados s&atilde;o tratados com confidencialidade, dentro dos limites legais. No entanto, podemos divulgar suas informa&ccedil;&otilde;es pessoais caso sejamos obrigados pela lei para faz&ecirc;-lo ou se voc&ecirc; violar nossos Termos de Servi&ccedil;o.</p>

<p><strong>SE&Ccedil;&Atilde;O 6 - COMPARTILHAMENTO DOS DADOS</strong></p>

<p>&nbsp;</p>

<p>O compartilhamento de dados do usu&aacute;rio ocorre apenas com os dados referentes a publica&ccedil;&otilde;es realizadas pelo pr&oacute;prio usu&aacute;rio, tais a&ccedil;&otilde;es s&atilde;o compartilhadas publicamente com os outros usu&aacute;rios.</p>

<p>Os dados do perfil do usu&aacute;rio s&atilde;o compartilhados publicamente em sistemas de busca e dentro da plataforma, sendo permitido ao usu&aacute;rio modificar tal configura&ccedil;&atilde;o para que seu perfil n&atilde;o apare&ccedil;a nos resultados de busca de tais ferramentas.</p>

<p><strong>&nbsp;</strong></p>

<p><strong>SE&Ccedil;&Atilde;O 6.1 - OS DADOS PESSOAIS ARMAZENADOS SER&Atilde;O TRANSFERIDOS A TERCEIROS?</strong></p>

<p>&nbsp;</p>

<p>Os dados pessoais n&atilde;o podem ser compartilhados com terceiros.</p>

<p>Com rela&ccedil;&atilde;o aos fornecedores de servi&ccedil;os terceirizados como processadores de transa&ccedil;&atilde;o de pagamento, informamos que cada qual tem sua pr&oacute;pria pol&iacute;tica de privacidade. Desse modo, recomendamos a leitura das suas pol&iacute;ticas de privacidade para compreens&atilde;o de quais informa&ccedil;&otilde;es pessoais ser&atilde;o usadas por esses fornecedores.</p>

<p>&nbsp;</p>

<p>(Se transfer&ecirc;ncia para outros pa&iacute;ses)</p>

<p>&nbsp;</p>

<p>Os fornecedores podem ser localizados ou possuir instala&ccedil;&otilde;es localizadas em pa&iacute;ses diferentes. Nessas condi&ccedil;&otilde;es, os dados pessoais transferidos podem se sujeitar &agrave;s leis de jurisdi&ccedil;&otilde;es nas quais o fornecedor de servi&ccedil;o ou suas instala&ccedil;&otilde;es est&atilde;o localizados.</p>

<p>Ao acessar nossos servi&ccedil;os e prover suas informa&ccedil;&otilde;es, voc&ecirc; est&aacute; consentindo o processamento, transfer&ecirc;ncia e armazenamento desta informa&ccedil;&atilde;o em outros pa&iacute;ses.</p>

<p>Ao ser redirecionado para um aplicativo ou site de terceiros, voc&ecirc; n&atilde;o ser&aacute; mais regido por essa Pol&iacute;tica de Privacidade ou pelos Termos de Servi&ccedil;o da nossa plataforma. N&atilde;o somos respons&aacute;veis pelas pr&aacute;ticas de privacidade de outros sites e lhe incentivamos a ler as declara&ccedil;&otilde;es de privacidade deles.</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 07 &ndash; COOKIES OU DADOS DE NAVEGA&Ccedil;&Atilde;O</strong></p>

<p>&nbsp;</p>

<p>Os cookies referem-se a arquivos de texto enviados pela plataforma ao computador do usu&aacute;rio e visitante e que nele ficam armazenados, com informa&ccedil;&otilde;es relacionadas &agrave; navega&ccedil;&atilde;o no site. Tais informa&ccedil;&otilde;es s&atilde;o relacionadas aos dados de acesso como local e hor&aacute;rio de acesso e s&atilde;o armazenadas pelo navegador do usu&aacute;rio e visitante para que o servidor da plataforma possa l&ecirc;-las posteriormente a fim de personalizar os servi&ccedil;os da plataforma.</p>

<p>O usu&aacute;rio e o visitante da plataforma manifesta conhecer e aceitar que pode ser utilizado um sistema de coleta de dados de navega&ccedil;&atilde;o mediante &agrave; utiliza&ccedil;&atilde;o de cookies.</p>

<p>O cookie persistente permanece no disco r&iacute;gido do usu&aacute;rio e visitante depois que o navegador &eacute; fechado e ser&aacute; usado pelo navegador em visitas subsequentes ao site. Os cookies persistentes podem ser removidos seguindo as instru&ccedil;&otilde;es do seu navegador. J&aacute; o cookie de sess&atilde;o &eacute; tempor&aacute;rio e desaparece depois que o navegador &eacute; fechado. &Eacute; poss&iacute;vel redefinir seu navegador da web para recusar todos os cookies, por&eacute;m alguns recursos da plataforma podem n&atilde;o funcionar corretamente se a capacidade de aceitar cookies estiver desabilitada.</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 8 - CONSENTIMENTO</strong></p>

<p>&nbsp;</p>

<p>Ao utilizar os servi&ccedil;os e fornecer as informa&ccedil;&otilde;es pessoais na plataforma, o usu&aacute;rio est&aacute; consentindo com a presente Pol&iacute;tica de Privacidade.</p>

<p>O usu&aacute;rio, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de cancelar seu cadastro, acessar e atualizar seus dados pessoais e garante a veracidade das informa&ccedil;&otilde;es por ele disponibilizadas.</p>

<p>O usu&aacute;rio tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve entrar em contato atrav&eacute;s do e-mail contato@fibrillare.com.br.</p>

<p>&nbsp;</p>

<p><strong>SE&Ccedil;&Atilde;O 9 - ALTERA&Ccedil;&Otilde;ES PARA ESSA POL&Iacute;TICA DE PRIVACIDADE</strong></p>

<p>&nbsp;</p>

<p>Reservamos o direito de modificar essa Pol&iacute;tica de Privacidade a qualquer momento, ent&atilde;o, &eacute; recomend&aacute;vel que o usu&aacute;rio e visitante revise-a com frequ&ecirc;ncia.</p>

<p>As altera&ccedil;&otilde;es e esclarecimentos v&atilde;o surtir efeito imediatamente ap&oacute;s sua publica&ccedil;&atilde;o na plataforma. Quando realizadas altera&ccedil;&otilde;es os usu&aacute;rios ser&atilde;o notificados. Ao utilizar o servi&ccedil;o ou fornecer informa&ccedil;&otilde;es pessoais ap&oacute;s eventuais modifica&ccedil;&otilde;es, o usu&aacute;rio e visitante demonstra sua concord&acirc;ncia com as novas normas.</p>

<p>Diante da fus&atilde;o ou venda da plataforma &agrave; outra empresa os dados dos usu&aacute;rios podem ser transferidas para os novos propriet&aacute;rios para que a perman&ecirc;ncia dos servi&ccedil;os oferecidos.</p>

<p><strong>&nbsp;</strong></p>

<p><strong>SE&Ccedil;&Atilde;O 10 &ndash; JURISDI&Ccedil;&Atilde;O PARA RESOLU&Ccedil;&Atilde;O DE CONFLITOS</strong></p>

<p>Para a solu&ccedil;&atilde;o de controv&eacute;rsias decorrentes do presente instrumento ser&aacute; aplicado integralmente o Direito brasileiro.</p>

<p>Os eventuais lit&iacute;gios dever&atilde;o ser apresentados no foro da comarca em que se encontra a sede da empresa.</p>

<p>&nbsp;</p>

        </div>
        </div>
        
    </section>
</template>

<script>
    export default {
        name: "Privacidade",
        data() {
            return {
                metaPageTitle: "",
                title: "",
                keywords: "",
                description: "",
            }
        },
        mounted() {
           
        },
        watch: {
           
        },
        metaInfo() {
            return {
                title: this.metaPageTitle,
                meta: [
                    { name: "title", vmid: "title", content: this.title },
                    { name: "keywords", vmid: "keywords", content: this.keywords },
                    { name: "description", vmid: "description", content: this.description },
                ],
            };
        }
    }
</script>

<style lang="scss" scoped>
 .conteudo-privacidade{
     margin-top: 200px;
 }
</style>

